// Step-up signal: the API answers 403 `step_up_required` when an operation needs a second factor
// verified recently (src/lib/stepUp.ts on the API). The client announces it here; the app's
// step-up dialog (components/StepUp.tsx) listens, asks for the code, and the person retries.
// `manage` opens the same dialog to set up or remove the factor (the account menu).

export type StepUpReason = 'mfa_required' | 'stale';
export type StepUpRequest = { mode: 'verify'; reason: StepUpReason } | { mode: 'manage' };

const listeners = new Set<(r: StepUpRequest) => void>();

export function onStepUp(fn: (r: StepUpRequest) => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

export function requestStepUp(r: StepUpRequest): void {
  for (const l of listeners) l(r);
}
